module.exports = __webpack_public_path__ + "img/support_b6.b6437f38.png";